import React from 'react'

import Icon from '../../../../../components/icon'
import { If } from '../../../../../components/if/if'
import Switch from '../../../../../components/switch'

import {
  ButtonWrapper,
  DeleteButton,
} from './styles'

type IProps = {
  remove: () => void;
  hasDeleteButton: boolean;
  handleActivationUpdate: () => void;
  active: boolean;
}

const FormActions = ({
  remove,
  hasDeleteButton,
  handleActivationUpdate,
  active,
}: IProps) => (
  <ButtonWrapper>
    <If condition={hasDeleteButton}>
      <DeleteButton
        type="button"
        onClick={remove}
      >
        <Icon name="trash" />
      </DeleteButton>
    </If>

    <Switch
      onClick={handleActivationUpdate}
      value={active}
    />
  </ButtonWrapper>
)

export default FormActions
